<agpr-dialog-container
    [id]="id + '.updateGlobalSourceDialog'"
    heading="Reports.sidebar.settings.globalSource.confirm.header"
    (close)="cancel()"
>
    <div class='agpr-updateGlobalSourceDialog-content' [agprLoading]="loading">
        <agpr-scroll-panel>
            <agpr-message
                *ngIf="alertMessageList && alertMessageList.length > 0"
                [severity]="alertType"
            >
                {{ alertMessage | localize }}
                <ul
                    *ngIf="alertMessageList && alertMessageList.length > 0"
                    class='agpr-list'
                >
                    <li
                        *ngFor="let itemMessage of alertMessageList"
                        class='agpr-list-item'
                    >
                        <span class="agpr-list-bullet fa fa-circle" aria-hidden="true"></span>
                        {{ itemMessage }}
                    </li>
                </ul>
            </agpr-message>
            <div
                *ngIf="message"
                [ngClass]="{ 'agpr-updateGlobalSourceDialog-messageBelowAlert': alertMessageList && alertMessageList.length > 0 }"
            >
                {{ message | localize }}
            </div>
            <div class="agpr-updateGlobalSourceDialog-radio">
                <agpr-radio
                    name="agpr-updateGlobalSourceDialog-update"
                    [id]="id + '.updateAll'"
                    [value]="updateGlobalSourceOptions.updateAll"
                    label="Reports.sidebar.settings.globalSource.confirm.radio.updateAll"
                    hiddenLabel="Reports.sidebar.settings.globalSource.confirm.radio.updateAll"
                    [(ngModel)]="selectedOption"
                    (ngModelChange)="showAlertList()"
                ></agpr-radio>
            </div>
            <div class="agpr-updateGlobalSourceDialog-radio">
                <agpr-radio
                    name="agpr-updateGlobalSourceDialog-update"
                    [id]="id + '.updateAll'"
                    [value]="updateGlobalSourceOptions.updatePartial"
                    label="Reports.sidebar.settings.globalSource.confirm.radio.updatePartial"
                    hiddenLabel="Reports.sidebar.settings.globalSource.confirm.radio.updatePartial"
                    [(ngModel)]="selectedOption"
                    (ngModelChange)="showAlertList()"
                ></agpr-radio>
            </div>
        </agpr-scroll-panel>
    </div>

    <ng-template #footerLeft>
        <agpr-button
            [id]="id + '.updateGlobalSourceDialog.cancel'"
            label="Core.button.cancel"
            [disabled]="loading"
            (click)="cancel()"
        ></agpr-button>
    </ng-template>
    <ng-template #footerRight>
        <agpr-button
            [id]="id + '.updateGlobalSourceDialog.ok'"
            label="Reports.sidebar.settings.globalSource.confirm.okLabel"
            [style]="buttonTypes.primary"
            [disabled]="loading"
            (click)="ok()"
        >
        </agpr-button>
    </ng-template>
</agpr-dialog-container>
